import React from "react";
import Navbar from "@/components/Navbar";
import FooterVariant from "@/components/FooterVariant";
import { useLocation } from "react-router-dom";
import FeaturebaseWidget from "@/components/FeaturebaseWidget";
import ImpersonationBanner from './ImpersonationBanner';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isComingSoon = location.pathname === "/coming-soon";

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="flex flex-col min-h-screen">
      <ImpersonationBanner />
      {!isComingSoon && <Navbar />}
      <main className="flex-1">
        {children}
      </main>
      {!isComingSoon && (
        <>
          <FooterVariant />
          <FeaturebaseWidget />
        </>
      )}
    </div>
  );
};

export default Layout;
